import React from 'react';
import { IPhoneText, PhoneSize } from './iphonecall';
import { PhoneLink } from '../link';
import RichText from '../rich-text';
import useProduct from '../../../../hooks/useProduct';
import { EventAction } from '../../../../services/analytics-interfaces';
import { getPosition } from '../../../../services/analytics-helper';

interface CreatePhoneText {
	size: PhoneSize;
	phoneNumber: string;
	brandPhoneDisplay: string;
}

const createText = ({
	size,
	phoneNumber,
	brandPhoneDisplay,
}: CreatePhoneText) => {
	if (!phoneNumber) {
		console.error('No phone number available');
		return '';
	}
	if (size === PhoneSize.LONG && brandPhoneDisplay) {
		return `<span className='whitespace-nowrap'>${brandPhoneDisplay}</span> <span className='whitespace-nowrap'>(${phoneNumber})</span>`;
	}

	return phoneNumber;
};

interface GetPhoneActionProps {
	position: string | undefined;
	isLargeScreen?: boolean;
	shortText: string | undefined;
	textProp: string | undefined;
}

const getPhoneAction = ({
	position,
	isLargeScreen = true,
	shortText,
	textProp,
}: GetPhoneActionProps) => {
	let positionKey = `Phone${position}`;
	if (textProp || (shortText && !isLargeScreen)) {
		positionKey = `CallUs${position}`;
	}
	return getPosition(positionKey) as EventAction;
};

const PhoneText = ({
	size = PhoneSize.SHORT,
	className = 'text-brand font-bold',
	text: textProp,
	position,
	shortText,
	phoneNumber: phoneNumberProp,
}: IPhoneText) => {
	const {
		params: { phoneNumber: phoneNumberParam, brandPhoneDisplay },
	} = useProduct();
	const phoneNumber = phoneNumberProp ?? (phoneNumberParam || '');
	const text = textProp ?? createText({ size, phoneNumber, brandPhoneDisplay });

	return (
		<>
			<span className={'hidden lg:inline'}>
				<PhoneLink
					phoneNumber={phoneNumber}
					action={getPhoneAction({
						position,
						shortText,
						textProp,
					})}>
					<span className={className}>
						<RichText html={text} />
					</span>
				</PhoneLink>
			</span>
			<span className="inline lg:hidden">
				<PhoneLink
					phoneNumber={phoneNumber}
					action={getPhoneAction({
						position,
						isLargeScreen: false,
						shortText,
						textProp,
					})}>
					<span className={className}>
						<RichText html={shortText || text} />
					</span>
				</PhoneLink>
			</span>
		</>
	);
};

export default PhoneText;
